module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "categoryOverview"
    }
  }, [_c('div', {
    staticClass: "card card-default mb-2 mt-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h2', {
    staticClass: "mt-0 strong"
  }, [_vm._v(_vm._s(_vm.labels.MY_APPLICATION_TEXT))]), _vm._v(" "), _c('div', {
    staticClass: "product-categories stretch-boxes"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [(_vm.isCurrentUserAdmin || _vm.userHasDigi()) ? _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                        My FOLBB platform\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, _vm._l((_vm.dashBoardDigiLinks), function(link) {
    return (_vm.isCurrentUserAdmin || _vm.userInGroup(link.Group)) ? _c('li', [_c('a', {
      staticClass: "underlined",
      attrs: {
        "href": link.Url
      }
    }, [_c('span', [_vm._v(_vm._s(link.Title))])])]) : _vm._e()
  }))])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("My FOLBB platform")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("My FOLBB platform")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fa0b030","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardHome/DashboardHome.vue
// module id = 186
// module chunks = 1